import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { REGEX_KEY } from '../../constants/regex.constants';

const defaultValues = {
  nombre: '',
  apellido1: '',
  apellido2: '',
  cargo: '',
  email: '',
  telefono: '',
  direccion: '',
  hechos: '',
};

const resolver = yupResolver(
  yup.object().shape({
    nombre: yup.string().required('Campo obligatorio'),
    apellido1: yup.string().required('Campo obligatorio'),
    apellido2: yup.string(),
    cargo: yup.string(),
    email: yup.string().email('Email no válido'),
    telefono: yup.string().matches(REGEX_KEY.PHONE, { message: 'Teléfono no válido', excludeEmptyString: true }),
    direccion: yup.string(),
    hechos: yup
      .string()
      .required('Campo obligatorio')
      .test('len', 'Máx. 150 caracteres', (val) => !val || val.length <= 150),
  })
);

export { defaultValues, resolver };
